import * as React from 'react';
import { ReactComponent as TemplatePdfSvg } from '../../assets/icons/mevo/ic-template-pdf.svg';
import IconPattern, { IconProps } from './_IconPattern';

const TemplatePdfIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={TemplatePdfSvg} variantPlaces={2} {...props} />;
};

export default TemplatePdfIcon;
